import { UPDATED_EMAIL_REGEX } from '@core/utilities/constants/regexes.js';

export const validateEmailFormat = email => UPDATED_EMAIL_REGEX.test(String(email).toLowerCase());
